import { FormattedMessage } from 'react-intl';
import React from 'react';
import { BATCHES_OPEN_VIEW_ID, BATCHES_VIEW_ID } from './view-id-constants';

export const BatchesOpen = {
  label: <FormattedMessage defaultMessage='Open' description='ordersPage.nav.openBatches' id='GhqCfc' />,
  id: BATCHES_OPEN_VIEW_ID,
  navigationOverride: '/shipments/batches/open',
  parentId: BATCHES_VIEW_ID,
};
